// Constants - Functions
import { protocols } from "../../../../config/constants";
import { importImages } from "../../../../config/functions";

export const GetAppBasicsProtocolData = (protocolId) => {
  const protocolImg = importImages(require.context("../../../../assets/images/protocols/reports/app/basics", false, /\.(png|jpe?g|svg)$/));

  const protocolsData = {
    [protocols.app.basic.MEMOSEQ.id]: {
      img: protocolImg["./memoseq.png"],
      imgResponsive: protocolImg["./memoseq_responsive.png"],
      name: "uppercaseProtocols_memoseqApp",
      description: "protocols_memoseqAppDescription",
      video: "protocols_memoseqAppVideo",
    },
    [protocols.app.basic.PLACE_IT.id]: {
      img: protocolImg["./place_it.png"],
      imgResponsive: protocolImg["./place_it_responsive.png"],
      name: "uppercaseProtocols_placeIt",
      description: "protocols_placeItDescription",
      video: "protocols_placeItVideo",
    },
    [protocols.app.basic.GUESS_WHAT.id]: {
      img: protocolImg["./guess_what.png"],
      imgResponsive: protocolImg["./guess_what_responsive.png"],
      name: "uppercaseProtocols_guessWhat",
      description: "protocols_guessWhatDescription",
      video: "protocols_guessWhatVideo",
    },
    [protocols.app.basic.PIANOSEQ.id]: {
      img: protocolImg["./pianoseq.png"],
      imgResponsive: protocolImg["./pianoseq_responsive.png"],
      name: "uppercaseProtocols_pianoseq",
      description: "protocols_pianoseqDescription",
      video: "protocols_pianoseqVideo",
    },
    [protocols.app.basic.BLOBS.id]: {
      img: protocolImg["./blobs.png"],
      imgResponsive: protocolImg["./blobs_responsive.png"],
      name: "uppercaseProtocols_blobs",
      description: "protocols_blobsDescription",
      video: "protocols_blobsVideo",
    },
    [protocols.app.basic.SHOPPING.id]: {
      img: protocolImg["./shopping.png"],
      imgResponsive: protocolImg["./shopping_responsive.png"],
      name: "uppercaseProtocols_shopping",
      description: "protocols_shoppingDescription",
      video: "protocols_shoppingVideo",
    },
    [protocols.app.basic.POPURRI.id]: {
      img: protocolImg["./potpourri.png"],
      imgResponsive: protocolImg["./potpourri_responsive.png"],
      name: "uppercaseProtocols_potpourri",
      description: "protocols_popurriDescription",
      video: "protocols_popurriVideo",
    },
    [protocols.app.basic.TWISTER.id]: {
      img: protocolImg["./twister.png"],
      imgResponsive: protocolImg["./twister_responsive.png"],
      name: "uppercaseProtocols_twister",
      description: "protocols_twisterDescription",
      video: "protocols_twisterVideo",
    },
    [protocols.app.basic.MEMORY.id]: {
      img: protocolImg["./memory.png"],
      imgResponsive: protocolImg["./memory_responsive.png"],
      name: "uppercaseProtocols_memory",
      description: "protocols_memoryDescription",
      video: "protocols_memoryVideo",
    },
    [protocols.app.basic.CLEANING.id]: {
      img: protocolImg["./cleaning.png"],
      imgResponsive: protocolImg["./cleaning_responsive.png"],
      name: "uppercaseProtocols_cleaning",
      description: "protocols_cleaningDescription",
      video: "protocols_cleaningVideo",
    },
    [protocols.app.basic.CONSTELLATIONS.id]: {
      img: protocolImg["./constellations.png"],
      imgResponsive: protocolImg["./constellations_responsive.png"],
      name: "uppercaseProtocols_constellationsApp",
      description: "protocols_constellationsAppDescription",
      video: "protocols_constellationsAppVideo",
    },
    [protocols.app.basic.BALLOONS_BASIC.id]: {
      img: protocolImg["./balloons.png"],
      imgResponsive: protocolImg["./balloons_responsive.png"],
      name: "uppercaseProtocols_balloonsBasic",
      description: "protocols_balloonsBasicDescription",
      video: "protocols_balloonsBasicVideo",
    },
    [protocols.app.basic.QUALITY_CONTROL_BASIC.id]: {
      img: protocolImg["./quality_control.png"],
      imgResponsive: protocolImg["./quality_control_responsive.png"],
      name: "uppercaseProtocols_qualityControlBasic",
      description: "protocols_qualityControlBasicDescription",
      video: "protocols_qualityControlBasicVideo",
    },
  };

  return protocolsData[Number(protocolId)];
};
